export default __webpack_public_path__ + "static/partner-bg-9b9b2dc87b00a0459a7dfa2167920550.jpg";